var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.23852L5.33341 4.1909M8.75589 3.09909L12.5654 5.27585C12.7988 5.40914 12.9927 5.60176 13.1276 5.83418C13.2624 6.0666 13.3335 6.33056 13.3334 6.59928V10.1635C13.3335 10.4322 13.2624 10.6961 13.1276 10.9286C12.9927 11.161 12.7988 11.3536 12.5654 11.4869L8.75589 13.6637C8.5257 13.7952 8.26518 13.8643 8.00008 13.8643C7.73498 13.8643 7.47447 13.7952 7.24427 13.6637L3.43475 11.4869C3.20141 11.3536 3.00747 11.161 2.87259 10.9286C2.73772 10.6961 2.6667 10.4322 2.66675 10.1635V6.59928C2.6667 6.33056 2.73772 6.0666 2.87259 5.83418C3.00747 5.60176 3.20141 5.40914 3.43475 5.27585L7.24427 3.09909C7.47447 2.9676 7.73498 2.89844 8.00008 2.89844C8.26518 2.89844 8.5257 2.9676 8.75589 3.09909Z",
    stroke: "#E84141",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04761 6.0957L7.2777 8.3738C7.4997 8.4933 7.74787 8.55586 7.99999 8.55586C8.2521 8.55586 8.50028 8.4933 8.72227 8.3738L12.9524 6.0957M7.99999 8.76237V13.7148",
    stroke: "#E84141",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowStock);
export default __webpack_public_path__ + "static/media/lowStock.2d31a618c5d1c8cdbe92c51c2877f7c3.svg";
export { ForwardRef as ReactComponent };